// @ts-check
import React, { useEffect, useState } from 'react'
import useFormManager from 'hooks/useFormManager'
import { H2 } from 'components/typography'
import TextInput from 'components/inputs/TextInput'
import { noop } from 'utils'
import defaultImg from 'assets/images/robot3.png'
import { useAuth } from 'context/AuthProvider'
import styles from './PersonalData.module.css'

const REQUIRED_FIELDS = ['name', 'email']

function PersonalData() {
  const [isValidImage, setIsValidImage] = useState(false)
  const { teacher } = useAuth()
  const imageUrl = teacher.profileUrl

  const { getErrorPropsByRequiredField, form } = useFormManager(
    REQUIRED_FIELDS,
    teacher
  )

  useEffect(() => {
    const img = new Image()
    img.onload = function () {
      setIsValidImage(true)
    }
    img.onerror = function () {
      setIsValidImage(false)
    }
    img.src = imageUrl
  }, [imageUrl])

  return (
    <section className={styles.section}>
      <H2>Datos personales 🤙</H2>
      <div className={styles.card}>
        <div className={styles.cardContent}>
          <div className={styles.containerProfileImg}>
            <img
              src={isValidImage ? imageUrl : defaultImg}
              alt='Foto de perfil'
              className={styles.profileImg}
            />
          </div>
          <div className={styles.personalInfoContainer}>
            <TextInput
              name='name'
              placeholder='Nombre completo'
              value={form.name}
              onChange={noop}
              {...getErrorPropsByRequiredField('name')}
            />
            <TextInput
              name='email'
              placeholder='Correo electrónico'
              value={form.email}
              onChange={noop}
              {...getErrorPropsByRequiredField('email')}
            />
          </div>
        </div>
      </div>
    </section>
  )
}

export default PersonalData
